// extracted by mini-css-extract-plugin
export var hidden = "_tu-0";